import { Location } from '@reach/router';
import * as React from 'react';

import { MarkdownProcessor } from 'modules/Markdown';

import { useCurrentNotification, useSeenCurrentNotification } from '../../hooks';
import { canRenderInThisPath } from '../../utils';
import { NotificationContent } from '../NotificationContent';
import { NotificationLink, NotificationText } from './styles';

const NOTIFICATION_COMPONENTS = {
  p: NotificationText,
  a: NotificationLink,
};

export const Notification: React.FC = () => {
  const { markup, variant, version, homeOnly, active } = useCurrentNotification();

  const [seenNotification, setSeenNotification] = useSeenCurrentNotification(version);

  const shouldDisableNotification = seenNotification || !active;

  if (shouldDisableNotification) {
    return null;
  }

  return (
    <Location>
      {({ location }): React.ReactNode => {
        if (!canRenderInThisPath(location.pathname, homeOnly)) {
          return null;
        }

        return (
          <MarkdownProcessor markup={markup} components={NOTIFICATION_COMPONENTS}>
            {({ children }): JSX.Element => (
              <NotificationContent variant={variant} onCloseClick={setSeenNotification}>
                {children}
              </NotificationContent>
            )}
          </MarkdownProcessor>
        );
      }}
    </Location>
  );
};
